import React from 'react';
import PropTypes from 'prop-types';

class PlusIcon extends React.Component {
    static propTypes = {
      color: PropTypes.string,
    };

    static contextTypes = {
      getString: PropTypes.func.isRequired,
    };

    static defaultProps = {
      color: '#1c7a8c',
    }

    render() {
      const { color } = this.props;
      return (
        <svg height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
          <g fill="none" fillRule="evenodd">
            <circle cx="16" cy="16" fill={color} r="16" />
            <path d="m17 23c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1v-6h-6c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h6v-6c0-.55228475.4477153-1 1-1s1 .44771525 1 1v6h6c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1h-6z" fill="#fff" fillRule="nonzero" />
          </g>
        </svg>
      );
    }
}

export default PlusIcon;
